module.exports = __webpack_public_path__ + "static/media/writing.5b821e62.svg";